import 'js/common.js'
import Vue from 'vue'
import Retrieve from 'component/sign/Retrieve.vue'

new Vue({
    el: '#app',
    render: h => h(Retrieve)
})


// WEBPACK FOOTER //
// ./src/entry/sign/retrieve.js